var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.00002H9.95625C9.83593 2.3032 9.47332 1.67128 8.93243 1.21578C8.39154 0.760288 7.70713 0.510498 7 0.510498C6.29287 0.510498 5.60846 0.760288 5.06757 1.21578C4.52668 1.67128 4.16407 2.3032 4.04375 3.00002H1.5C1.23478 3.00002 0.98043 3.10538 0.792893 3.29292C0.605357 3.48045 0.5 3.73481 0.5 4.00002V12C0.5 12.2652 0.605357 12.5196 0.792893 12.7071C0.98043 12.8947 1.23478 13 1.5 13H12.5C12.7652 13 13.0196 12.8947 13.2071 12.7071C13.3946 12.5196 13.5 12.2652 13.5 12V4.00002C13.5 3.73481 13.3946 3.48045 13.2071 3.29292C13.0196 3.10538 12.7652 3.00002 12.5 3.00002ZM7 1.50002C7.44329 1.50087 7.87382 1.64851 8.22434 1.91988C8.57487 2.19125 8.82564 2.57107 8.9375 3.00002H5.0625C5.17436 2.57107 5.42513 2.19125 5.77566 1.91988C6.12618 1.64851 6.55671 1.50087 7 1.50002Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageIcon);
export default __webpack_public_path__ + "static/media/luggage-icon.dbc5a7a1a1dacea35da1f699910677a5.svg";
export { ForwardRef as ReactComponent };